
<app-semester-select
    [showPreferredBookingInfo]="showPreferredBookingInfo"
    [openForRegistrationOnly]="true"
    [showInCoursesOnly]="true"
    (onClick)="onSemesterSelect($event)">

</app-semester-select>
